export class InvoiceProductTypeModel {
  public id = 0;
  public label = '';

  constructor() {}

  public fromJSON(json) {
    for (const propName in json) {
      if (json.hasOwnProperty(propName)) {
        this[propName] = json[propName];
      }
    }
    return this;
  }

  public fromJSONs(jsons) {
    const refs: InvoiceProductTypeModel[] = [];
    jsons.forEach(json => {
      refs.push(new InvoiceProductTypeModel().fromJSON(json));
    });
    return refs;
  }
}
